module.exports = __webpack_public_path__ + "entry-150bfe9b/google-play-badge-en-7652c3c7d4f44d11701ff37731079477.svg";